const swiper = () => {
    customProductSlider();
    imageCarousel();
}

const imageCarousel = () => {
    // Get all the sliders with the class name .image-text-carousel
    const sliders = document.querySelectorAll('.image-text-carousel');

    // Check if there are any sliders on the page
    if (sliders.length > 0) {
        // Loop through each slider and initialize Swiper
        sliders.forEach((slider) => {
            let thisSlider = slider.querySelector('.image-carousel');
            let thisCSwiper = new Swiper(thisSlider, {
                slidesPerView: 4,
                spaceBetween: 60,
                loop: true,
                autoplay: {
                    delay: 500,  // Changed this to 2000 milliseconds (2 seconds)
                },
                // Breakpoints
                breakpoints: {
                    320: {
                        slidesPerView: 2,  // Show two slides
                        spaceBetween: 20  // Reduce spacing between slides for mobile view
                    },
                    768: {
                        slidesPerView: 1,  // Show one slide
                        spaceBetween: 0  // Reduce spacing between slides for mobile view
                    },
                    1024: {
                        slidesPerView: 3,  // Show three slides
                        spaceBetween: 30
                    },
                    1400: {
                        slidesPerView: 4,  // Show four slides (default behavior)
                        spaceBetween: 60
                    }
                }
            });
        });
    }
}


const customProductSlider = () => {
    // #f1 Swiper Slider
    new Swiper('.f1-slider', {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 10
    });

    // f2-slider Swiper Slider
    const f2Swiper = new Swiper('.f2-slider', {
        slidesPerView: 3,
        direction: 'horizontal',  // default direction
        loop: true,
        spaceBetween: 10,
        navigation: {
            nextEl: '.swiper-next__custom',
            prevEl: '.swiper-prev__custom'
        },
        breakpoints: {
            // when window width is <= 767px
            768: {
                direction: 'vertical'
            }
        }
    });

    f2Swiper.on('slideChange', function() {
        document.querySelector('.f1-slider').swiper.slideTo(f2Swiper.realIndex);
    });
}

document.addEventListener("DOMContentLoaded", function() {
    swiper();
});